// extracted by mini-css-extract-plugin
export default {"monospaceId":"SubmissionHistoryList_monospaceId__N6l3G","boldCount":"SubmissionHistoryList_boldCount__sAmAF"};